<app-ag-grid id="calculated-table"
             class="display-block lh-34 full-height"
             [suppressContextMenu]="true"
             [gridOptions]="{
                suppressDragLeaveHidesColumns: true,
                rowHeight: 35,
                groupHeaderHeight: 64,
                headerHeight: 64,
                colResizeDefault: 'shift'
             }"
             [paginationPageSize]="25"
             [defaultColDef]="defaultColDef"
             [columnDefs]="columnDefs$ | async"
             [loader]="loading$ | async"
             [rowData]="metrics$ | async">
  <ng-template #calculatedActionsColumn let-row>
    <div class="actions full-height display-flex flex-align-center justify-content-end">
      <app-icon icon="edit"
                [disabled]="appS.isNotDatasetAdmin"
                class="display-inline-flex"
                [style]="'material-icons-outlined cursor color-grey-light color-blue-hover'"
                [matTooltip]="'tooltip.edit' | translate"
                (onClick)="onUpdate(row)"></app-icon>
      <app-icon icon="delete"
                [disabled]="appS.isNotDatasetAdmin || row.payload.relationships.metric?.data?.id"
                class="display-inline-flex"
                [style]="'material-icons-outlined cursor color-grey-light color-red-hover'"
                [matTooltip]="'tooltip.delete' | translate"
                (onClick)="onDelete(row)"></app-icon>
    </div>
  </ng-template>
</app-ag-grid>
